import { render, staticRenderFns } from "./tag-editor.vue?vue&type=template&id=4f984dfd"
import script from "./tag-editor.vue?vue&type=script&lang=ts"
export * from "./tag-editor.vue?vue&type=script&lang=ts"
import style0 from "./tag-editor.vue?vue&type=style&index=0&id=4f984dfd&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f984dfd')) {
      api.createRecord('4f984dfd', component.options)
    } else {
      api.reload('4f984dfd', component.options)
    }
    module.hot.accept("./tag-editor.vue?vue&type=template&id=4f984dfd", function () {
      api.rerender('4f984dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/tag-editor.vue"
export default component.exports